<template>
    <div class="address-select">
        <div class="scrollerView" :style="{ height: (300) + 'px' }">
            <scroller :on-refresh="refresh" :on-infinite="infinite" ref="infinite" class="scroller">
                <div class="ul">
                    <div class="li td-fsc" v-for="(item, index) in dataSources" :key="index" @click="select" :data-index="index">
                        <div class="radio td-fsc">
                            <div class="radio"></div>
                        </div>
                        <div class="address td-f1">
                            <div class="consignee">
                                <span>{{ item.name}}</span>
                                <span class="phone">{{ item.mobile }}</span>
                            </div>
                            <div class="site-info">
                                {{ item.area }}{{ item.address }}
                            </div>
                        </div>
                    </div>
                </div>
            </scroller>
            <div class="btn-wrap add-btn-wrap pos-a z99">
                <div class="btn-item add-btn-item flex ccc" @click="_onPressToNavigate('', 'addAddress')">
                    <div class="btn-title">新增地址</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "picker-address",
    props: ['show'],
    data() {
        return {
            page: 0,
            limit: 20,
            dataSources: []
        };
    },
    computed: {
        showAddress() {
            return this.show
        },
    },
    created() {
        // 实例创建完成
        this.requestData()
    },
    methods: {

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function() {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // 请求地址数据
        async requestData() {
            let url = this.API.user_address_address_list;
            let params = {

                page: this.page,
                limit: this.limit,
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.data;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                if (this.page === 1) {
                    dataSourcesTemp = dataList
                    this._dataSource = result.data.data;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                this.dataSources = dataSourcesTemp
                this.$refs.infinite.finishInfinite(dataList.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 选择地址
        select(e) {
            let { index } = e.currentTarget.dataset
            let item = this.dataSources[index]
            this.$emit('success', item)
        }
    },
};
</script>
<style lang="less" scoped>
.address-select {
    position: relative;
    border-top: solid #eee 1px;
}

.ul {
    .li {
        background: #fff;
        padding: 10px;
        border-bottom: solid #eee 1px;

        .consignee {
            color: #333;
            font-size: 15px;
            font-weight: 500;

            .phone {
                padding-left: 20px;
            }
        }

        .site-info {
            font-size: 14px;
            color: #666;
        }

        .radio {
            img {
                width: 15px;
                height: 15px;
                object-fit: contain;
                margin-right: 10px;
            }

            .radio {
                width: 15px;
                height: 15px;
                border: 1px solid #979797;
                border-radius: 50%;
                margin-right: 10px;
                box-sizing: border-box;
            }
        }
    }
}

.add-btn-wrap {
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding-bottom: calc(0 + env(safe-area-inset-bottom) / 2);
    .add-btn-item {
        color: #fff;
        height: 4rem;
        margin: 15px 15px;
        border-radius: 4rem;
        background: linear-gradient(225deg,#9cb2f4,#6472e8);
    }
}
</style>